'use strict'

import React from 'react'
import { View, StyleSheet } from 'react-native'
import FSText from 'app/fs/components/FSText'

import NotificationUnreadIndicator from './NotificationUnreadIndicator'
import NotificationThumbnail from './NotificationThumbnail'
import NotificationTimestamp from './NotificationTimestamp'
import NotificationContent from './NotificationContent'
import { colors } from 'app/fs/lib/styles'
import styles from './styles'

export default class BuddyAcceptedNotification extends React.Component {
  render() {
    var notif = this.props.notification

    return (
      <View style={styles.notification}>
        <NotificationUnreadIndicator {...this.props} />
        <NotificationThumbnail {...this.props} currentUserId={this.props.currentUserId} />

        <NotificationContent {...this.props} iconSize={16} iconName="buddies" iconColor={colors.challengePurple}>
          <FSText style={styles.bodyText}>{notif.alert_text}</FSText>
        </NotificationContent>

        <NotificationTimestamp {...this.props} />
      </View>
    )
  }
}
